<template>
	<editor
		id="editor"
		style="width: 100%;height: 100%;"
		model-events="change keydown blur focus paste"
		v-model="editorValue"
		:init="editorInit"
		v-on="$listeners"
		@onInit="onEditorInit"
	></editor>
</template>

<script>
	let that = null
	import tinymce from 'tinymce/tinymce'
	import 'tinymce/plugins/image'
	import 'tinymce/plugins/media'
	import 'tinymce/plugins/lists'
	import 'tinymce/themes/silver/theme'
	import './icons.js'
	import Editor from '@tinymce/tinymce-vue'
	export default {
		name: 'cl-editor',
		components: {
			Editor
		},
		props: {
			value: {
				type: String,
				default: ''
			},
			// 能否上传文件
			isUploadFile: {
				type: Boolean,
				default: false,
			},
			placeholder: {
				type: String,
				default: function () {
					return this.$t('common.请输入')
					// this.$t('ca.如让图片视频独占一行，请与其他内容用回车隔开。')
				}
			}
		},
		model: {
			prop: 'value',
			event: 'input'
		},
		data() {
            let title = this.$t('schedule.标题')

			return {
				description: '富文本组件',
				editorValue: '', // 编辑器内容
				editorInit: {
                    language_url: '/tinymce/langs/zh_CN.js',
                    language: 'zh_CN',
                    height: 520,
                    skin_url: '/tinymce/skins/ui/oxide',
                    plugins: 'lists image media',
                    toolbar1: `formatselect | fontsizeselect | forecolor bold italic underline strikethrough | alignleft aligncenter alignright | bullist numlist | upload_file`,
                    fontsize_formats: '10px 11px 12px 13px 14px 16px 18px 20px 24px 36px 48px',
                    block_formats: `${this.$t('ca.段落') + ' '}=p;${title} 1=h1;${title} 2=h2;${title} 3=h3;`,
                    branding: false,
                    menubar: false,
                    elementpath: false, // 隐藏底栏的元素路径
                    placeholder: this.placeholder,
                    color_map: [
                        'a486e8', // 色值
                        'a486e8', // hover 显示文案
                        '638af6',
                        '638af6',
                        'a6e5ae',
                        'a6e5ae',
                        'FFD24B',
                        'FFD24B',
                        'E46759',
                        'E46759',
                        '83439F',
                        '83439F',
                        '244DD1',
                        '244DD1',
                        '5AC050',
                        '5AC050',
                        'F0820E',
                        'F0820E',
                        'C23320',
                        'C23320',
                        '000000',
                        '000000',
                        '3A3A3A',
                        '3A3A3A',
                        '81818A',
                        '81818A',
                        'B7B7BF',
                        'B7B7BF',
                        'CED4D9',
                        'CED4D9',
                    ],
                    /* 编辑器初始化之前 */
                    setup: function(editor) {
						if (this.isUploadFile) {
							editor.ui.registry.addIcon(
								'axupimgs',
								`<svg style="fill: none;" width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M5 11L6.77037 8.28912C7.51033 7.15606 9.13845 7.06961 9.99424 8.11794L10.859 9.17725C11.2115 9.60914 11.8666 9.62364 12.238 9.20776V9.20776C12.614 8.78664 13.2792 8.80773 13.6278 9.25181L15 11" stroke="#080808" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
									<path d="M5 14H15" stroke="#080808" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
									<path d="M7 17H13" stroke="#080808" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
									<path d="M14.359 10C14.758 9.57559 15 9.0181 15 8.40753C15 7.07789 13.8521 6 12.4362 6C11.3 6 10.3364 6.69399 10 7.65517" stroke="#080808" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
									<path d="M16 17.6442H17C18.1046 17.6442 19 16.7488 19 15.6442V11.0817V4.51923C19 3.41466 18.1046 2.51923 17 2.51923H10.7086C10.2501 2.51923 9.80565 2.36175 9.44947 2.07316L8.67553 1.44607C8.31935 1.15748 7.87485 1 7.41644 1H5.5H3C1.89543 1 1 1.89543 1 3V15.6442C1 16.7488 1.89543 17.6442 3 17.6442H4" stroke="#080808" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
								</svg>`
							)
							editor.ui.registry.addButton('upload_file', {
								icon: 'axupimgs',
								onAction: () => {
									that.dialogVisible = true
								},
							})
						}
                    },
                },
				activeEditor: null, // 激活的编辑器实例
			}
		},

		watch: {
			value: {
				immediate: true,
				handler() {
					this.editorValue = this.value
				}
			}
		},

        mounted() {
            // 监听dom属性变化
            this.addAttrListener()
            // 弹窗监听
            this.addAttrListenerDio()
        },

		methods: {
			/* 编辑器初始化后 */
			onEditorInit(e, activeEditor) {
				this.activeEditor = activeEditor
			},

            /* 监听插件颜色属性变化时，将字母和下划线统一变色 */
            addAttrListener() {
                const target = document.getElementById('tox-icon-text-color__color')
                if (!target) {
                    // 这个是插件内的元素，$nextTick无法获取，setTimeout获取成功时间在1s以上。
                    setTimeout(() => {
                        this.addAttrListener()
                    }, 200)
                    return
                }

                let attrListener = new MutationObserver((mutations) => {
                    let colorDom = mutations[0].target
                    let color = colorDom.getAttribute('fill')
                    colorDom.nextSibling.setAttribute('fill', color)
                })
                attrListener.observe(target, { attributes: true, attributeFilter: ['fill'] })
            },

            // 弹窗监听 为了修改色值close
            addAttrListenerDio() {
                const target = document.getElementsByClassName('tox-tinymce-aux')[0]
                if (!target) {
                    // 这个是插件内的元素，$nextTick无法获取，setTimeout获取成功时间在1s以上。
                    setTimeout(() => {
                        this.addAttrListenerDio()
                    }, 200)
                    return
                }

                let attrListener = new MutationObserver((mutations) => {
                    if (
                        mutations.length > 1 &&
                        mutations[0].target.childNodes[0].childNodes[1].childNodes[0].childNodes[1]
                    ) {
                        const val = mutations[0].target.childNodes[0].childNodes[1].childNodes[0].childNodes[1]
                        val.innerHTML = `<div id='close_icon'>
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 1L12.9999 12.9999" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M13 1L1 12.9999" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>`
                    }
                })
                attrListener.observe(target, { childList: true })
            },
		}

	}
</script>

<style lang="scss" scoped>
</style>

<style lang="scss">
    .tox-tinymce {
		height: 100% !important;
		border: none!important;
		padding: 16px;
		border-radius: 6px!important;
		background-color: #fff;
		/* 隐藏边框 */
		.tox-toolbar {
			background: none!important;
			border: none!important;
		}
		/* 底部计字区域隐藏 */
		.tox-statusbar {
			display: none!important;
		}
		/* 顶部工具栏背景色 */
		.tox-toolbar-overlord {
			background: none!important;
		}
		/* 输入区域背景色 */
		.tox-edit-area__iframe {
			background: none!important;
		}
		/* 按钮宽度 */
		.tox-tbtn__select-label {
			width: auto!important;
		}
		/* 按钮间距 */
		.tox-tbtn {
			margin: 0 3px!important;
		}

		/* 去掉原间隔线 */
		.tox-toolbar__group {
			border: none!important;
		}
		/* 添加新间隔线 */
		.tox-toolbar__group:not(:last-of-type)::after {
			width: 1px!important;
			height: 24px!important;
			background-color: rgba(175, 175, 175, 0.3)!important;
			content: ' ';
		}
        .tox-button--naked {
            border: none !important;
            color: #b7b7bf !important;
            &:hover {
                background: transparent !important;
                border: none !important;
            }
        }
    }
    .tox .tox-dialog {
        width: 400px !important;
        border-radius: 12px !important;
        font-weight: 500 !important;
    }
    .tox-dialog-wrap__backdrop {
        background-color: rgba(0, 0, 0, 0.5) !important;
    }
    .tox-button.tox-button--secondary {
        box-sizing: border-box !important;
        min-width: 92px !important;
        padding-left: 25px !important;
        padding-right: 25px !important;
        background-color: transparent !important;
        color: #afafaf !important;
        font-family: PingFangMedium !important;
        font-weight: 500 !important;
        font-size: 14px !important;
        border-radius: 6px !important;
    }
    .tox-dialog__footer-end .tox-button.tox-button--secondary {
        box-sizing: border-box !important;
        height: 36px;
        min-width: 92px !important;
        padding-left: 25px !important;
        padding-right: 25px !important;
        margin-left: 10px !important;
        background: #f3f3f3 !important;
        // font-family: PingFangMedium !important;
        font-weight: 500 !important;
        font-size: 14px !important;
        color: #81818a !important;
        border-radius: 6px !important;
        border: none!important;
    }
    .tox-dialog__footer-end .tox-button:nth-of-type(2) {
        box-sizing: border-box !important;
        height: 36px;
        min-width: 92px !important;
        padding-left: 25px !important;
        padding-right: 25px !important;
        margin-left: 10px !important;
        border: 1px solid var(--primary-color) !important;
        background-color: var(--primary-color) !important;
        // font-family: PingFangMedium !important;
        font-weight: 500 !important;
        font-size: 14px !important;
        color: #fff !important;
        border-radius: 6px !important;
        box-shadow: 0px 6px 8px rgba(54, 99, 225, 0.3)!important;
    }
    .tox-dialog__header {
        padding: 16px 20px !important;
        background: url('~@i/ca/cat/color_header_bg.png') top center no-repeat !important;
        background-size: cover !important;
        .tox-dialog__title {
            width: 100%;
            text-align: center;
            padding-left: 40px !important;
        }
    }
    .tox-dialog__body {
        padding: 0 10px !important;
        .tox-sv-palette {
            overflow: hidden;
            border-radius: 6px;
        }
        .tox-rgba-preview {
            overflow: hidden !important;
            height: 40px !important;
            border-radius: 6px !important;
        }
    }
    .tox-dialog__footer {
        padding: 16px 32px !important;
        /* background-color: #F3F2FA!important; */
    }
    .tox-swatches__row {
        div {
            width: 22px !important;
            height: 22px !important;
            margin: 5px !important;
            border-radius: 4px !important;
        }
    }
    .tox-swatches__row:last-child {
        margin-top: 6px;
    }
    .tox .tox-swatch:focus,
    .tox .tox-swatch:hover {
        box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.7) inset !important;
        transform: scale(1.2) !important;
    }
    .tox .tox-tiered-menu .tox-menu {
        overflow: inherit !important;
        margin-top: 6px;
        box-shadow: 0px 6px 16px rgba(129, 129, 138, 0.3);
    }
    .tox .tox-tiered-menu .tox-menu::after {
        position: absolute;
        top: -6px;
        left: 20px;
        z-index: 100;
        width: 0;
        height: 0;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        border-bottom: 6px solid #fff;
        content: '';
    }
    #close_icon {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 24px;
        height: 24px;
    }
    // 关闭弹框icon颜色
    .tox .tox-button--naked {
        color: #B7B7BF!important;
        &:hover:not(:disabled) {
            background-color: rgba(54, 99, 225, 0.08)!important;
            border-color: transparent!important;
            color: $base-color-theme!important;
        }
    }
    /* 按钮hover颜色 */
    .tox-tinymce .tox-tbtn:hover {
        background: transparentize($base-color-theme, 0.88)!important;
    }
    /* 按钮选中颜色 */
    .tox-tinymce .tox-tbtn--enabled {
        background: transparentize($base-color-theme, 0.88)!important;
    }
</style>